<template>
  <div class="box-card">
    <el-row :gutter="12">
      <el-col :span="19">
        <span class="title">{{ $t('message.title.importFile') }}</span>
      </el-col>
      <el-col :span="4">
        <el-steps :active="active" finish-status="success">
          <el-step></el-step>
          <el-step></el-step>
          <el-step></el-step>
        </el-steps>
      </el-col>
      <el-dialog title="导入操作手册" :visible.sync="dialogVisible" width="60%">
        <span class="importManual">
          <p2>第一步：选择数据类型</p2><br />
          <p2>第二步：导出模板</p2>
          <img src="@/assets/import/import1.png" width="100%" alt="" />
          <img src="@/assets/import/import2.png" width="100%" alt="" />
          <p2>第三步：准备模板数据</p2>
          <img src="@/assets/import/import3.png" width="100%" alt="" />
          <p2>第四步：回到系统，进行下一步操作</p2>
          <img src="@/assets/import/import4.png" width="100%" alt="" />
          <p2>第五步：上传文件</p2>
          <img src="@/assets/import/import6.png" width="100%" alt="" />
          <p2>第六步：上传成功，文件中的物料成功导入到系统中</p2>
        </span>
      </el-dialog>
      <el-col style="margin-top: 5px">
        <el-divider></el-divider>
      </el-col>
      <el-col>
        <el-carousel ref="carousel" class="content" arrow="never" indicator-position="none" :autoplay="autop">
          <el-carousel-item class="item">
            <el-row style="margin-top: 70px; height: 240px">

              <el-col :span="15" :offset=5 style="font-weight: 600">
                <span>{{ $t('message.title.fileModel') + ' : ' }}</span>
                <el-cascader size="small" class="input-model" v-model="value" :options="options" @change="selectType"
                  clearable="">
                </el-cascader>
              </el-col>

              <vxe-grid ref="xTable" v-show="tableShow" v-bind="addTableList">
              </vxe-grid>
              <el-col :span="15" :offset=5 style="margin-top:25px">
                <span>
                  <el-tag style="margin-left: 8.8%;" type="text" @click="dialogVisible = true" class="tip-tag">
                    <i class="el-icon-info" style="font-size:14px"></i>
                    <span>{{ $t('message.tips.tip') + ': ' }}</span>
                    {{ $t('message.tips.exportModel') }}
                  </el-tag>
                </span>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6" :offset="16">
                <div style="width:200px;overflow:hidden">
                  <el-button type="primary" size="small" @click="next">{{ $t('message.button.next') }}</el-button>
                  <el-button type="primary" size="small" style="margin-left: 5px" :disabled="!isSelect"
                    @click="downLoad">{{ $t('message.button.exportModel') }}</el-button>
                  <br><br>
                  <div style="color: #fff">
                    <p @click="exportSubClassObjects">导出子类对象</p>
                    <p @click="xx">rebuildWBS</p>
                  </div>
                </div>
              </el-col>
            </el-row>

          </el-carousel-item>
          <el-carousel-item style="height:560px" v-if='systemName.indexOf("奥斯汀") == -1'>
            <!-- <el-carousel-item style="height:560px" v-if = 'systemName.indexOf("taylor") != -1'> -->
            <div class="model lastPage">
              <el-row>
                <el-col :span="21" :offset="1">
                  <add-change @getChangeInfo="addList" @listDbClick="addList" :baseId='baseId'></add-change>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" :offset="16">
                  <el-button size="small" @click="next" :disabled="!changeId">{{ $t('message.button.next')
                    }}</el-button>
                  <el-button size="small" @click="cancel">{{ $t('message.button.cancel') }}</el-button>
                </el-col>
              </el-row>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="model">
              <el-upload class="upload-demo" action="" :show-file-list="false" :before-upload="importFile">
                <span style="display: inline-blcok">{{ $t('message.title.fileImport') }}:</span>
                <el-button size="small" type="primary" style="margin-left: 5px">{{ $t('message.button.toImport')
                  }}</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>

              <br><br>

              <!-- <el-checkbox v-model="isGenerateCodeNumber">{{$t('message.title.isGenerateCodeNumber')}}</el-checkbox> -->
            </div>

            <el-row>
              <el-col :span="6" :offset="16">
                <el-button size="small" @click="cancel">{{ $t('message.button.cancel') }}</el-button>
              </el-col>
            </el-row>
          </el-carousel-item>
          <el-carousel-item style="height:560px">
            <div class="model">

              <!-- <li v-for="item in fileInfo" class="file-info" :key="item.id">
                  <div class="table-list">
                    <span class="list-key-1">{{ item.name }}</span>
                    <span style="display: inline-block; margin: 0 6px">:</span>
                    <span class="list-val" :title="item.val">{{
                      item.val
                    }}</span>
                  </div>
                </li> -->

              <div>
                <div class="file-info" v-for="item in fileInfo" :key="item.id">
                  <div class="table-list">
                    <div style="width: 160px;display: flex;">
                      <div style="margin-left: auto;">
                        {{ item.name }} :
                      </div>
                    </div>
                    <div :title="item.val">
                      {{ item.val }}
                    </div>
                  </div>
                </div>

                <div class="file-info">
                  <div class="table-list">
                    <div style="width: 160px;display: flex;">
                      <div style="margin-left: auto;">
                        {{ "变更单编号(点击跳转)" }} :
                      </div>
                    </div>
                    <div>
                      <el-link type="primary" @click="jumpToChange">{{ changeItem.title }}</el-link>
                    </div>
                  </div>

                </div>
                <div class="file-info" v-if="errorInfo.list.length">
                  <div class="table-list">
                    <div style="width: 160px;display: flex;">
                      <div style="margin-left: auto;">
                        {{ errorInfo.name }} :
                      </div>
                    </div>
                    <div style="height: 300px;overflow-y: auto;">
                      <div v-for="item in errorInfo.list" :key="item">
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="display: flex;margin-top: 15px;">
                <div style="margin-left: 42% ">
                  <el-button size="small" @click="cancel" v-if="errorInfo.list.length">{{
                    $t('message.button.cancel') }}</el-button>
                  <el-button size="small" @click="done" v-else>完成</el-button>
                </div>
              </div>
            </div>

          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>
    <vxe-grid ref="subClassObjects" v-show="false" v-bind="subClassObjectsList"></vxe-grid>
  </div>
</template>

<script>
import axios from "axios";
import XLSXS from 'xlsx-js-style'
import addChange from '@/components/relSearchAdd.vue';
export default {
  data() {
    return {
      dialogVisible: false,
      isGenerateCodeNumber: false,
      options: [],
      tableShow: false,
      value: "",
      active: 0,
      autop: false,
      isSelect: false,
      urlList: [
        { baseId: 101, url: "/pmdm/import/importCommonItems" },
        // { baseId: 105, url: "/pmdm/import/importManufacturers" },
        // { baseId: 106, url: "/pmdm/import/importManufacturerParts" },
      ],
      baseId: 104,
      changeId: '',
      systemName: '',
      addTableList: {
        columns: [],
      },
      subClassObjectsList: {
        columns: [],
        data: [],
      },
      fileInfo: [],
      changeItem: {
        id: '',
        classId: '',
        subclassId: '',
        title: ''
      },
      errorInfo: {
        name: '错误列表',
        list: []
      },
    };
  },
  components: {
    // TableModel: () => import("./table/tableModel.vue"),
    addChange
  },
  methods: {
    jumpToChange() {
      this.getLink(this.changeItem);
    },
    Excel() {

      const header = this.list.map(i => {
        const color = i.requireType ? '#f00' : '#000'
        const obj =
        {
          v: i.name,
          alignment: {
            vertical: 'center', // 垂直居中
            horizontal: 'center'
          },
          t: 's',
          s: {
            font: {
              name: "微软雅黑",
              sz: 16,
              bold: true,
              color
            },
          }
        }
        return obj
      })
      let body = [header];

      // body.unshift(...h);// 将定义好的表头添加到 body 中
      const sheet = XLSXS.utils.aoa_to_sheet(body);// aoa_to_sheet 将二维数组转成 sheet

      // // 设置列宽
      const cols = new Array(this.list.length).fill({ wch: 20 })
      sheet['!cols'] = cols; // 将cols添加到sheet中

      // const rows = new Array(this.list.length + 2).fill({ hpx: 21 })
      // rows[0] = { hpx: 40 }
      // sheet['!rows'] = rows; // 将rows添加到sheet中，设置行高

      // const merges = ['A1:' + String.fromCharCode(64 + parseInt(this.column.length)) + '1'];
      // sheet['!merges'] = merges.map((item) => XLSXS.utils.decode_range(item))

      const getCharCol = (n) => {
        let s = '',
          m = 0
        while (n > 0 || n == 0) {
          m = n % 26 + 1
          s = String.fromCharCode(m + 64) + s
          n = (n - m) / 26
        }
        return s
      }
      console.log(sheet);

      this.list.map((i, e) => {
        // const n = e + 1;
        // console.log(i);
        const m = getCharCol(e) + '1';
        const color = i['requiredType'] ? 'F56C6C' : '000'
        // console.log({ r: i.requiredType, color });
        sheet[m].s = {

          font: {
            name: "宋体",
            sz: 11,
            // bold: true,
            color: { rgb: color }
          },
          border: {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
          },
        }
      })


      const workbook = XLSXS.utils.book_new();// 创建虚拟的 workbook
      XLSXS.utils.book_append_sheet(workbook, sheet, 'sheet1'); // 向 workbook 中添加 sheet
      XLSXS.writeFile(workbook, this.exportTitle + '.xlsx'); // 导出 workbook
    },
    async exportSubClassObjects() {
      console.log("exportSubClassObjects");
      console.log(this.value);
      if (this.value.length == 0) {
        this.$message.error("请选择物料子类");
        return false;
      }
      if (this.value[0] != 101) {
        this.$message.error("请选择物料子类");
        return false;
      }

      let m = this.modelNames.filter((i) => i != null);
      const name = m.find((i) => {
        return i.value == this.value[1];
      }).label;


      var args = {
        // subClassId:this.value[2],
        subClassId: 0
      };

      let obj = {
        baseId: this.value[0],
        classId: this.value[1],
        // subClassId: this.value[2],
        subClassId: 0
      };

      let url2 = `/pmdm/importTemplate/generateAllColumnInfo${this.params(obj)}`;
      axios.post(url2).then((res) => {
        let n = Object.values(res.data.object.fieldList);
        console.log(n);
        // this.addTableList.columns = n.map((i, e) => {
        //   return { field: i.id, title: i.name };
        // });
        this.subClassObjectsList.columns = n.map((i, e) => {
          return { field: i.id + "", title: i.name };
        });
      });

      var getItemsUrl = `/pmdm/items/getItemsBySubClassId${this.params(args)}`;
      const {
        data: res,
      } = await this.$http.get(getItemsUrl);
      console.log(res);
      if (res.code == 200) {
        console.log(res);
        this.subClassObjectsList.data = res.object.items;
        console.log(res.object.items);
        console.log(this.subClassObjectsList.columns);
        console.log(this.subClassObjectsList.data);

      }
      setTimeout(() => {
        this.exportSubClassObjectsEvent(name);
      }, 500);
      // this.exportSubClassObjectsEvent(name);
    },
    exportSubClassObjectsEvent(n) {
      console.log("exportSubClassObjectsEvent");
      console.log(this.subClassObjectsList.data);
      this.$refs.subClassObjects.updateData();
      this.$refs.subClassObjects.exportData({
        filename: n + "对象",
        sheetName: "Sheet1",
        type: "xlsx",
      });
      console.log(this.subClassObjectsList.data);
    },
    selectType(e) {
      this.isSelect = Boolean(e.length);
      const [baseId, classId] = this.value;

      if (this.isSelect) {
        let obj = {
          baseId, classId,
          subClassId: 0,
        };
        let url = `/pmdm/importTemplate/getImportTemplateByItemClass${this.params(obj)}`;
        axios.post(url).then((res) => {
          // let n = Object.values(res.data.object.fieldList);
          // console.log(n);
          // this.addTableList.columns = n.map((i, e) => {
          //   return { field: i.id, title: i.name };
          // });

          const n = res.data.object.fieldList;
          this.addTableList.columns = n.map((i, e) => {
            return { field: i.id, title: i.name };
          });
          // this.list = n.map(i => i.name)
          this.list = [...n]
        });

      }
    },
    addList(arr) { //添加
      // console.log(row);
      let row = arr[0];
      console.log(row);
      this.changeId = row.itemId;
      const { itemId, itemClass, itemSubClass } = row;
      this.changeItem = {
        id: itemId,
        classId: itemClass,
        subclassId: itemSubClass,
        title: row[0]
      };
    },
    importFile(file) {
      console.log(file);
      let obj_name = {};
      obj_name.name = "文件名";
      obj_name.val = file["name"];
      let obj_time = {};
      obj_time.name = "上传时间";
      obj_time.val = this.formatDate(file["lastModified"]);
      let arr = [obj_name, obj_time];

      let fd = new FormData();
      console.log(fd);
      fd.append("file", file);
      fd.append("id", this.value[0]);
      fd.append("classId", this.value[1]);
      fd.append("subClassId", 0);
      fd.append("isGenerateCodeNumber", this.isGenerateCodeNumber);
      fd.append("changeId", this.changeId);
      // fd.append("changeId", 0);
      // fd.append("changeClassId", 0);
      // fd.append("changeSubClassId", 0);
      console.log(fd);
      console.log(this.isGenerateCodeNumber);

      let url = this.urlList.filter((i) => {
        return i.baseId == this.value[0];
      })[0].url;
      console.log(url);
      axios.post(url, fd).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {

          const { errorList = '[]', ...list } = res.data.object;

          if (!errorList.length) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            const n = Object.keys(list).map((i, e) => {
              return {
                name: i,
                val: Object.values(list)[e],
              };
            });
            this.fileInfo = arr.concat(n);
             return
          }
          this.fileInfo = arr;
          this.errorInfo.list = JSON.parse(errorList);
          this.next();
        }
      });
    },
    next() {
      console.log(this.value);
      this.$refs.carousel.next();
      this.active++;
    },
    cancel() {
      this.$refs.carousel.prev();
      this.active--;
    },
    downLoad() {
      //  console.log(this.value.length);
      if (this.value.length == 0) {
        this.$message.error("请选择文件类型");
        return false;
      }

      let m = this.modelNames.filter((i) => i != null);
      console.log(m, this.value);
      const name = m.find((i) => {
        return i.value == this.value[1];
      }).label;
      // this.exportDataEvent(name);

      this.exportTitle = name + "模板文件";
      this.Excel();
    },
    exportDataEvent(n) {
      this.$refs.xTable.exportData({
        filename: n + "模板文件",
        sheetName: "Sheet1",
        type: "xlsx",
      });
    },

    async getInfo() {
      const { data: res } = await this.$http.get(
        "/pmdm/admin/getClassListNewStyle"
      );
      console.log(res);
      // const list = [101, 105, 106];
      this.options = res.object.clsList.filter((i) => i.value === 101
        //  {
        //   return list.indexOf(i.value) != -1;
        // }
      );
      this.options[0].children.map(i => {
        delete i.children;
        return i;
      })
      // let arr = [];

      // for (let i = 0; i < this.options.length; i++) {
      //   const e = this.options[i];
      //   console.log(e.children);
      //   if (e.children!=null) {
      //     for (let j = 0; j < e.children.length; j++) {
      //       const l = e.children[j];
      //       arr = arr.concat(l.children);
      //     }
      //   }
      // }
      // this.modelNames = arr;
      this.modelNames = [...this.options[0].children]
    },
    done() {
      this.$emit("deletePage", "/importFile");
    },
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    xx() {
      console.log(111);
      axios.get('/ppm/project/updateAllProjectDisplayOrder').then(
        _ => {
          // this.$message.success('ok')
          console.log('rebuild WBS ok');
        }
      )
    }
  },
  created() {
    this.getInfo();
    this.systemName = window.sessionStorage.getItem("systemName");
  },
};
</script>
<style>
/* .box-card .el-carousel__container {
  height: 480px !important;
} */
</style>
<style scoped lang="scss">
.box-card {
  /* width: 100%; */
  /* height: 660px; */
  padding: 20px;
  background: #fff;
}

.file-info {
  width: 100%;
  margin-left: 120px;
  text-align: left;
  margin-bottom: 8px;

  .table-list {
    display: flex;
    align-content: center;
    font-size: 12px;
  }
}

.content {
  width: 96%;
  height: 560px;
}

.item {
  height: 560px;
}

/* .model {
  margin-top: 25px;
  margin-left: -120px;
  text-align: center;
  height: 240px;
  padding-top: 45px;
} */


.model {
  margin-top: 25px;
  margin-left: 120px;
  /* text-align: center; */
  height: 640px;
  padding-top: 45px;
}

.model.lastPage {
  /* margin-top: 25px;
  margin-left: 20px;
  text-align: center;
  height: 460px;
  padding-top: 25px; */
}

.input-model {
  margin-left: 5px;
  width: 36%;
}

.next-click {
  /* margin-left: 480px;
  text-align: center; */
  width: 160px;
  overflow: hidden;
  /* float: right;
    margin-top: 140px;
    margin-left: 120px; */
}

/* .title {
  height: 32px;
  line-height: 32px;
} */
.title {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
}

.importManual p2 {
  font-size: 15px;
  font-weight: bold;
  margin: 20px;
  height: 36px;
  line-height: 36px;
}

.tip-tag {
  cursor: pointer;
}
</style>
